import MediaLibraryItem from "@/models/Media/Library/Item/MediaLibraryItem";
import BossModel from "@/models/BossModel";

export default class Item extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/accordion/item';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetAccordionItems';

    static fields() {
        return {
            id: this.number(null).nullable(),
            platinum_widget_accordion_id: this.number(null).nullable(),
            media_library_item_id: this.number(null).nullable(),
            rank: this.number(null),
            title_nl: this.attr(null),
            title_en: this.attr(null),
            html_nl: this.attr(null),
            html_en: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            mediaLibraryItem: this.belongsTo(MediaLibraryItem, 'media_library_item_id'),
        }
    }

    /**
     *
     * @param accordionId
     * @returns {*}
     */
    static fetchByAccordionId(accordionId) {
        return this.api()
            .where('platinum_widget_accordion_id', accordionId)
            .with(['mediaLibraryItem'])
            .limit(0)
            .get(true);
    }
}
